import { Fragment, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../component/layout/footer";
import Header from "../component/layout/header";
import "../assets/css/signup.css";
import Category from "../component/section/category";
import Swal from "sweetalert2";
import { useRef } from "react";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const SignupPage = () => {
    const navigate = useNavigate();
 
    /* ------------------------------------
        FORM STATE
    ------------------------------------ */
    const [role, setRole] = useState("student");
    const [step, setStep] = useState(1); // **Step number**
    //set errors
    const [errors, setErrors] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
    Category: "",
    Experience:"",

    Address: "",
    phone: "",
    // bio: "",
    education: "",
studentPhone: "",

   country_id: "",
  state_id: "",
  city_id: "",
  Address_line1: ""


});
const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

const [showPassword, setShowPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);
const [countries, setCountries] = useState([]);
const [states, setStates] = useState([]);
const [cities, setCities] = useState([]);
const [submittedStep, setSubmittedStep] = useState(false);
const [submittedStep1, setSubmittedStep1] = useState(false);
const [isSubmitting, setIsSubmitting] = useState(false);
//for email
const [emailChecking, setEmailChecking] = useState(false);
const emailTimeoutRef = useRef(null);
//for mobile
//const [phoneChecking, setPhoneChecking] = useState(false);
//const phoneTimeoutRef = useRef(null);
const [searchParams] = useSearchParams();
const referralCodeFromURL = searchParams.get("ref");
//languages
const [languageInput, setLanguageInput] = useState("");
const [languages, setLanguages] = useState([]);
const [languageSuggestions, setLanguageSuggestions] = useState([]);
const [selectedLanguages, setSelectedLanguages] = useState([]);

  //form data 
    const [formData, setFormData] = useState({
        username: "",
        email: "",
        password: "",
        confirmPassword: "",
        Category: "",
        Experience:"",
        Address: "",
        phone: "",
        // bio: "",
        education: "",
        gender: "",

        phone_code: "+91",

        studentPhone: "",
        // ✅ ADDRESS FIELDS
          country_id: "",
          state_id: "",
          city_id: "",
          city: "",
          area: "",
          pincode: "",
        Address_line1:"",
        Address_line2:"",
        location:"",
        profession_id: "",
        profession_details: "",
        preferred_languages:"",


    });

    //useffect for countries
 useEffect(() => {
   fetch("https://kalakakshaaha.com/kks/api/v1/countries")
     .then(res => res.json())
     .then(data => {
       if (data.success) {
         setCountries(data.countries);
       }
     })
     .catch(err => console.error("COUNTRIES ERROR:", err));
 }, []);


 //handlechange
    const handleChange = (e) => {
        
    const { name, value } = e.target;

    // Validation: username should NOT contain numbers
    if (name === "username") {
        const onlyLetters = /^[A-Za-z ]*$/;

        if (!onlyLetters.test(value)) {
            // show validation error
            setErrors({ ...errors, username: "Numbers are not allowed" });
            return; // stop updating the input
        } else {
            // clear the error if text is valid
            setErrors({ ...errors, username: "" });
        }
    }


if (name === "password") {
  if (!value) {
    setErrors(prev => ({ ...prev, password: "Password is required" }));
  } else if (!PASSWORD_REGEX.test(value)) {
    setErrors(prev => ({
      ...prev,
      password:
        "8+ chars, uppercase, lowercase, number & special character required"
    }));
  } else {
    setErrors(prev => ({ ...prev, password: "" }));
  }
}

if (name === "confirmPassword") {
  if (!value) {
    setErrors(prev => ({
      ...prev,
      confirmPassword: "Confirm password is required"
    }));
  } else if (value !== formData.password) {
    setErrors(prev => ({
      ...prev,
      confirmPassword: "Passwords do not match"
    }));
  } else {
    setErrors(prev => ({ ...prev, confirmPassword: "" }));
  }
}

/* -------------------
     ON COUNTRY CHANGE
  ------------------- */
  if (e.target.name === "country_id") {
    const countryId = e.target.value;
    setFormData({ ...formData, country_id: countryId, state_id: "", city_id: "" });

    // Fetch states
    fetch(`https://kalakakshaaha.com/kks/api/v1/states/${countryId}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setStates(data.states);
          setCities([]); // Reset cities
        }
      });
  }

  /* -------------------
     ON STATE CHANGE
  ------------------- */
  if (e.target.name === "state_id") {
    const stateId = e.target.value;
    setFormData({ ...formData, state_id: stateId, city_id: "" });

    // Fetch cities
    fetch(`https://kalakakshaaha.com/kks/api/v1/cities/${stateId}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setCities(data.cities);
        }
      });
  }


  // update the form normally
setFormData({ ...formData, [name]: value });

// for email change
 if (name === "email") {
    setErrors({ ...errors, email: "" });

    // basic format check first
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) return;

    // debounce
    if (emailTimeoutRef.current) {
      clearTimeout(emailTimeoutRef.current);
    }

    emailTimeoutRef.current = setTimeout(async () => {
      setEmailChecking(true);

      try {
        const res = await fetch(
          `https://kalakakshaaha.com/kks/api/v1/check-email?email=${value}&role=student`
        );
        const data = await res.json();

        if (data.exists) {
          setErrors((prev) => ({
            ...prev,
            email: "Email already registered"
          }));
        }
      } catch (err) {
        console.error(err);
      } finally {
        setEmailChecking(false);
      }
    }, 600); // ⏱️ wait until user stops typing
  }

{/*
// 📱 MOBILE NUMBER VALIDATION (LIKE EMAIL)
if (name === "studentPhone") {
  // allow only digits
  const digitsOnly = value.replace(/\D/g, "");

  // update value (max 10)
  if (digitsOnly.length <= 10) {
    setFormData(prev => ({
      ...prev,
      studentPhone: digitsOnly
    }));
  }

  // clear error while typing
  setErrors(prev => ({ ...prev, studentPhone: "" }));

  // stop if not 10 digits
  if (digitsOnly.length !== 10) return;

  // debounce API call
  if (phoneTimeoutRef.current) {
    clearTimeout(phoneTimeoutRef.current);
  }

  phoneTimeoutRef.current = setTimeout(async () => {
    setPhoneChecking(true);

    try {
      const res = await fetch(
        `https://kalakakshaaha.com/kks/api/v1/check-phone?phone=${digitsOnly}`
      );
      const data = await res.json();

      if (data.exists) {
        setErrors(prev => ({
          ...prev,
          studentPhone: "Mobile number already registered"
        }));
      }
    } catch (err) {
      console.error(err);
    } finally {
      setPhoneChecking(false);
    }
  }, 600);

  return; // ⛔ stop further handleChange execution
}*/}


if (name === "studentPhone") {
  const digits = value.replace(/\D/g, "");

  if (digits.length <= 10) {
    setFormData(prev => ({
      ...prev,
      studentPhone: digits
    }));
  }

  // clear error while typing
  if (errors.studentPhone) {
    setErrors(prev => ({ ...prev, studentPhone: "" }));
  }

  return;
}


//  CLEAR ERROR WHILE TYPING
if (errors[name]) {
  setErrors(prev => ({ ...prev, [name]: "" }));
}

};


//isStepvalid 
const isStepValid = () => {

  // STEP 1 — Account
if (step === 1) {
  return (
    formData.username.trim().length > 0 &&
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email) &&
    PASSWORD_REGEX.test(formData.password) &&
    formData.password === formData.confirmPassword
  );
}


  // STEP 2 — Personal Info
  if (step === 2) {
    return (
      formData.gender &&
      /^[0-9]{10}$/.test(formData.studentPhone) &&
      formData.profession_id &&
      formData.preferred_languages?.length > 0
    );
  }

  // STEP 3 — Address
  if (step === 3) {
    return (
      formData.country_id &&
      formData.state_id &&
      (formData.city_id || formData.city.trim().length > 0) &&
      formData.area.trim().length > 0 &&
      /^[0-9]{6}$/.test(formData.pincode) &&
      formData.location.trim().length > 0 &&
      formData.Address_line1.trim().length >= 1
    );
  }

  return false;
};


    /* ------------------------------------
        VALIDATION PER STEP
    ------------------------------------ */
    const validateStep = (cityIdOverride = null) => {
        if (role === "student") {
            if (step === 1) {
               let newErrors = {};

    if (!formData.username.trim()) {
        newErrors.username = "Username is required";
    }

    if (!formData.email.trim()) {
        newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
        newErrors.email = "Enter a valid email";
    }
    

   
    
    if (!formData.password.trim()) {
  newErrors.password = "Password is required";
} else if (
 !PASSWORD_REGEX.test(formData.password)

) {
  newErrors.password =
    "8+ chars, upper, lower, number & special character required";
}


    if (!formData.confirmPassword.trim()) {
        newErrors.confirmPassword = "Confirm password is required";
    } 
    else if (formData.password !== formData.confirmPassword) {
        newErrors.confirmPassword = "Passwords do not match";
    }



    setErrors(newErrors);

    return Object.keys(newErrors).length === 0; // true if no errors
            }

 if (step === 2) {
      let newErrors = {};
       if (!formData.gender.trim()) newErrors.gender = "Gender is required";

    if (!formData.studentPhone.trim()) {
        newErrors.studentPhone = "Phone number is required";
    } 
    else if (!/^[0-9]{10}$/.test(formData.studentPhone)) {
        newErrors.studentPhone = "Enter a valid 10-digit phone";
    }
      if (!formData.profession_id) {
  newErrors.profession_id = "Profession is required";
}

if (!formData.preferred_languages || formData.preferred_languages.length === 0) {
  newErrors.preferred_languages = "Select at least one language";
}
setErrors(newErrors);

    return Object.keys(newErrors).length === 0; // true if no errors

 }
            
 if (step === 3) {
    let newErrors = {};
const cityId = cityIdOverride ?? formData.city_id;

    const pincode = String(formData.pincode || "").padStart(6, "0");
 
    if (!formData.country_id.trim()) newErrors.country_id = "Country is required";
    if (!formData.state_id.trim()) newErrors.state_id = "State is required";
    // if (!formData.city_id) newErrors.city_id = "City is required";
   if (!cityId && !formData.city.trim()) {
      newErrors.city_id = "City is required";
    }

    if (!formData.area.trim()) newErrors.area = "Area is required";

    if (!formData.pincode) newErrors.pincode = "Pincode is required";
    else if (!/^[0-9]{6}$/.test(pincode))
        newErrors.pincode = "Pincode must be 6 digits";

    if (!formData.location.trim()) newErrors.location = "Location is required";

    if (!formData.Address_line1.trim())
       newErrors.Address_line1 = "Address is required";
    

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
}
   
        }
        return true;
    };
 
    //next step
const nextStep = () => {
  setSubmittedStep(true);
    setSubmittedStep1(true);   // ✅ ADD THIS

  if (validateStep()) {
    setSubmittedStep(false);
    setStep(step + 1);
  }
};

//prev step
const prevStep = () => {
        if (step > 1) setStep(step - 1);
    };
 

    /* ------------------------------------
        SUBMIT HANDLER
    ------------------------------------ */
   const handleSignup = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    
 let finalCityId = formData.city_id;

  // 🔥 CREATE CITY & GET ID
  if (!finalCityId && formData.city) {
    finalCityId = await ensureCityExists();
  }
  setIsSubmitting(true);

  // 🔥 HARD STOP
  // if (!finalCityId) {
  //   setErrors(prev => ({ ...prev, city_id: "City is required" }));
  //   return;
  // }

  // 🔥 VALIDATE USING FINAL CITY ID

  if (!finalCityId && !formData.city.trim()) {

  setErrors(prev => ({ ...prev, city_id: "City is required" }));

  return;

}
 
  if (!validateStep(finalCityId)) return;

    let url = "";
    let payload = {};
    
            payload = {
            username: formData.username,
            email: formData.email,
            password: formData.password,
            education: formData.education,
            gender: formData.gender,
              phone_code: formData.phone_code,   // ✅ ADD THIS

            phone: formData.studentPhone,
            country_id: formData.country_id,
           state_id: formData.state_id,
           city_id: finalCityId,
           area: formData.area,
           pincode: formData.pincode,
           area: formData.area,
            pincode: formData.pincode,
            location: formData.location,
            Address_line1: formData.Address_line1,
            Address_line2: formData.Address_line2,
            
        };
        payload.profession_id = formData.profession_id;
        payload.profession_details = formData.profession_details;
        payload.preferred_languages = formData.preferred_languages;

        //student registraion api

const res = await fetch("https://kalakakshaaha.com/kks/api/v1/register/student", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        // body: JSON.stringify(payload)
        body: JSON.stringify({
    ...payload,
    referral_code: referralCodeFromURL //👈 SEND IT
  })
    });

    const data = await res.json();
  if (data.success) {
  Swal.fire({
    icon: "success",
    title: "Registration Successful 🎉",
    text: "A verification link has been sent to your email.",
    showConfirmButton: false,
    timer: 4000,
    timerProgressBar: true,
    width: 420,
    heightAuto: false,
    allowOutsideClick: false,
    didClose: () => {
      navigate("/login");
    }
  });
} else {
  Swal.fire({
    icon: "error",
    title: "Registration Failed",
    text: data.message || "Something went wrong",
    confirmButtonText: "OK",
    width: 400,
    heightAuto: false
  });
 
  // 🎯 highlight backend field error if sent
  if (data.field) {
    setErrors(prev => ({
      ...prev,
      [data.field]: data.message
    }));
  }
}
};

//handle city chnage
const [filteredCities, setFilteredCities] = useState([]);
const [showSuggestions, setShowSuggestions] = useState(false);

const handleCityChange = (e) => {
    const raw = e.target.value;

    // Remove numbers, capitalize first letter
    const lettersOnly = raw.replace(/[0-9]/g, "");
    const value = lettersOnly.charAt(0).toUpperCase() + lettersOnly.slice(1);

    setFormData(prev => ({
        ...prev,
        city: value,
        city_id: "" // reset city_id while typing
    }));

    // ✅ CLEAR CITY ERROR WHILE TYPING
    if (errors.city_id) {
        setErrors(prev => ({
            ...prev,
            city_id: ""
        }));
    }

    if (!value) {
        setFilteredCities([]);
        setShowSuggestions(false);
        return;
    }

    const results = cities.filter(c =>
        c.city_name.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredCities(results);
    setShowSuggestions(true);
};

const selectCity = (cityObj) => {
    // setFormData({
    //     ...formData,
    //     city: cityObj.city_name,
    //     city_id: cityObj.id
    // });
    setFormData(prev => ({
  ...prev,
  city: cityObj.city_name,
  city_id: cityObj.id
}));

    // ✅ CLEAR CITY ERROR
    setErrors(prev => ({
        ...prev,
        city_id: ""
    }));
    setShowSuggestions(false);
};

const ensureCityExists = async () => {
  if (!formData.city || formData.city_id) return formData.city_id;

  const res = await fetch(
    "https://kalakakshaaha.com/kks/api/v1/city/create-or-get",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        city_name: formData.city,
        state_id: formData.state_id,
        country_id: formData.country_id
      })
    }
  );

  const data = await res.json();

  if (data.success) {
    setFormData(prev => ({
      ...prev,
      city_id: data.city_id
    }));
    setErrors(prev => ({
    ...prev,
    city_id: ""   // ✅ CLEAR ERROR
  }));

    setCities(prev => [
      ...prev,
      { id: data.city_id, city_name: formData.city }
    ]);

    return data.city_id; // 🔥 IMPORTANT
  }

  return null;
};

 
// profession
const [professions, setProfessions] = useState([]);



useEffect(() => {
  fetch("https://kalakakshaaha.com/kks/api/v1/professions")
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        setProfessions(data.professions);
      }
    });
}, []);




//laguages api
useEffect(() => {
  fetch("https://kalakakshaaha.com/kks/api/v1/get-languages")
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        setLanguages(data.languages);
      }
    });

}, []);

const handleLanguageInput = (e) => {
  const value = e.target.value;
  setLanguageInput(value);

  if (!value) {
    setLanguageSuggestions([]);
    return;
  }

  const filtered = languages.filter(
    l =>
      l.language_name.toLowerCase().includes(value.toLowerCase()) &&
      !selectedLanguages.some(s => s.id === l.id)
  );

  setLanguageSuggestions(filtered);
};

const addLanguage = (lang) => {
  setSelectedLanguages(prev => [...prev, lang]);
  setLanguageInput("");
  setLanguageSuggestions([]);

  setFormData(prev => ({
    ...prev,
    preferred_languages: [...(prev.preferred_languages || []), lang.id]
  }));
};

const removeLanguage = (id) => {
  setSelectedLanguages(prev => prev.filter(l => l.id !== id));

  setFormData(prev => ({
    ...prev,
    preferred_languages: prev.preferred_languages.filter(lid => lid !== id)
  }));
};



    /* ------------------------------------
        PROGRESS BAR
    ------------------------------------ */
 
    const totalSteps = role === "student" ? 3 : 3;
    const progress = (step / totalSteps) * 100;
 
    return (
        <Fragment>
            <Header />
 
            {/* <PageHeader title={"Sign Up"} curPage={"Register"} /> */}
 
           <div className="student-signup-wrapper fadeIn" >
 
    <div className="container py-5" >
           <div style={{marginTop:110}}>
        <div className="signup-card shadow-lg" style={{margin:"10px auto",marginTop:'50px'}}>
 
            <h3 className="text-center signup-title">Create Your Account</h3>
 
            {/* PROGRESS BAR */}
            <div className="progress my-4" style={{ height: "10px", borderRadius:"20px" }}>
                <div
                    className="progress-bar signup-progress"
                    role="progressbar"
                    style={{ width: `${progress}%` }}
                ></div>
            </div>
 
          
            {/* FORM START */}
            <form className="account-form step-animation" onSubmit={handleSignup}>
 

                {/* STUDENT → Step 1 */}
                {step === 1 && (
                    <div className="step-box">

                        {/* //username */}
                      <div className={`input-wrapper ${errors.username ? "error-active" : ""}`}>

                                    <input type="text" name="username" placeholder="Name"
                                        className="step-input" value={formData.username} onChange={handleChange} />
            <p className={`validation-msg ${errors.username ? "show" : ""}`}>
                    {errors.username}
                </p>
                      </div>

                        {/* email */}
                       <div className={`input-wrapper ${errors.email ? "error-active" : ""}`}>
                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      className="step-input"
                      value={formData.email}
                      onChange={handleChange}
                    />

                    <p className="hint">
                      Please enter a valid email for verification
                    </p>

                    {emailChecking && (
                      <p className="hint">Checking email availability...</p>
                    )}

                    <p className={`validation-msg ${errors.email ? "show" : ""}`}>
                      {errors.email}
                    </p>
                         </div>

                         

                          {/* password */}
                          <div className={`input-wrapper ${errors.password ? "error-active" : ""}`}>

                          <div className="password-box">
                      <input
                          type={showPassword ? "text" : "password"}
                          name="password"
                          placeholder="Password"
                          className="step-input"
                          value={formData.password}
                          onChange={handleChange}
                      />
                    <i
                          className={`fa-solid ${showPassword ? "fa-eye" : "fa-eye-slash"} eye-icon`}
                          onClick={() => setShowPassword(!showPassword)}
                      ></i>
                  </div>
                  <p className={`validation-msg ${errors.password ? "show" : ""}`}>
                      {errors.password}
                  </p>
                          </div>

                          {/* confirm password */}
                          <div className={`input-wrapper ${errors.confirmPassword ? "error-active" : ""}`}>

                  <div className="password-box">

                      <input
                          type={showConfirmPassword ? "text" : "password"}
                          name="confirmPassword"
                          placeholder="Confirm Password"
                          className="step-input"
                          value={formData.confirmPassword}
                          onChange={handleChange}
                      />
                      
                      <i
                          className={`fa-solid ${showConfirmPassword ? "fa-eye" : "fa-eye-slash"} eye-icon`}
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      ></i>
                  </div>
                  <p className={`validation-msg ${errors.confirmPassword ? "show" : ""}`}>
                      {errors.confirmPassword}
                  </p>
                          </div>
      </div>
                )}

{role ==="student" && step === 2 &&(
                      <div className="step-box">
                         {/* gender */}
                          <div className="input-wrapper"> <div className="select-box">
                          <select
                              className="step-input"
                              name="gender"
                              value={formData.gender}
                              onChange={handleChange}
                          >
                              <option value="">Select Gender</option>
                              <option value="male">Male</option>
                              <option value="female">Female</option>
                              <option value="other">Other</option>
                          </select>
                          {submittedStep1 && errors.gender && (
                              <p className="validation-msg show">{errors.gender}</p>
                          )}

                                </div> 
                          </div>

                          {/* phone      */}
<div className="input-wrapper">
  <div className="phone-row">
    <select
      className="step-input"
      name="phone_code"
      value={formData.phone_code}
      onChange={handleChange}
    >
      <option value="+91">India (+91)</option>
      <option value="+1">USA (+1)</option>
      <option value="+44">UK (+44)</option>
    </select>

    <input
      type="tel"
      name="studentPhone"
      className="step-input"
      placeholder="Enter your Mobile Number"
      value={formData.studentPhone}
      onChange={handleChange}
      maxLength={10}
    />
  </div>

  <p className={`validation-msg ${errors.studentPhone ? "show" : ""}`}>
    {errors.studentPhone}
  </p>
</div>





                         {/* PROFESSION DROPDOWN */}
                        <div className="input-wrapper">
                          <select
                            name="profession_id"
                            className="step-input"
                            value={formData.profession_id}
                            onChange={handleChange}
                          >
                            <option value="">Select Profession</option>
                            {professions.map(p => (
                              <option key={p.id} value={p.id}>
                                {p.profession_name}
                              </option>
                            ))}
                          </select>

                          {submittedStep && errors.profession_id && (
                            <p className="validation-msg show">{errors.profession_id}</p>
                          )}
                        </div>

                        {/* PROFESSION DETAILS */}
                        <div className="input-wrapper">
                         
                          <input 
                            type="text" 
                            name="profession_details" 
                            placeholder="Specialization" 
                            className="step-input" 
                            value={formData.profession_details} 
                            onChange={handleChange} 
                        />
                        </div>

                        {/* PREFERRED LEARNING LANGUAGE */}
                        <div className="input-wrapper">
                          <label className="step-heading">Preferred Learning Language</label>

                          <div className="skills-input-wrapper">
                            {selectedLanguages.map(lang => (
                              <span key={lang.id} className="skill-chip-inline">
                                {lang.language_name}
                                <button className="remove-chip-inline"  onClick={() => removeLanguage(lang.id)}>×</button>
                              </span>
                            ))}

                            <input
                              type="text"
                              className="skills-inline-input"
                              placeholder="Type language..."
                              value={languageInput}
                              onChange={handleLanguageInput}
                            />
                            
                          </div>
                        {submittedStep && errors.preferred_languages && (
                                    <p className="validation-msg show">{errors.preferred_languages}</p>
                                  )}
                          {languageSuggestions.length > 0 && (
                            <ul className="skills-suggestions">
                              {languageSuggestions.map(l => (
                                <li key={l.id} onClick={() => addLanguage(l)}>
                                  {l.language_name}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
</div>
  
)}
               {/* step 2 */}
 { role === "student" && step === 3 && (
                     <div className="step-box">
                        {/* <h4 className="step-heading">More About You</h4> */}
                    <div className="address-inputs">

                      {/* country selection       */}
                        <div className={`input-wrapper ${errors.country ? "error-active" : ""}`}>
                                {/* <input type="text" name="country" className="step-input" placeholder="Country" value={formData.country}
                                onChange={handleChange}/> */}
                               <select name="country_id" className="step-input" value={formData.country_id}
                                        onChange={handleChange}
                                                                            >
                                    <option value="">Select Country</option>

                                        {countries.map(c => (
                                         <option key={c.id} value={c.id}>
                                        {c.country_name}
                                    </option>
                                     ))}
                                 </select>

                                <p className={`validation-msg ${errors.country_id ? "show" : ""}`}>
                                 {errors.country_id}
                                </p>
                        </div>

                          {/* state selection  */}
                        <div className={`input-wrapper ${errors.state ? "error-active" : ""}`}>
                            {/* <input type="text" name="state"  className={`step-input ${errors.state ? "error-active" : ""}`} placeholder="State" value={formData.state}
                                         onChange={handleChange}/> */}
                                         <select name="state_id" className="step-input" value={formData.state_id} onChange={handleChange}
                                             disabled={!formData.country_id}>
                                             <option value="">Select State</option>

                                                    {states.map(s => (
                                                          <option key={s.id} value={s.id}>
                                                                    {s.state_name}
                                                               </option>
                                                     ))}
                                            </select>

                                    <p className={`validation-msg ${errors.state_id ? "show" : ""}`}>
                                       {errors.state_id}
                                    </p>
                        </div>
                    </div>
                    <div className="address-inputs">
                          {/* pincode */}

                        <div className={`input-wrapper ${errors.pincode ? "error-active" : ""}`}>
                                <input type="number"  className="step-input" name="pincode" placeholder="Pincode/ZIP" value={formData.pincode} 
                                onChange={(e) => {
                                    if (e.target.value.length <= 6) {handleChange(e)}}}/>
                                <p className={`validation-msg ${errors.pincode ? "show" : ""}`}>
                                 {errors.pincode}
                                </p>
                        </div>

                           {/* city */}
                        <div className={`input-wrapper ${errors.city ? "error-active" : ""}`}>
    <input
        type="text"
        className="step-input no-margin"
        name="city"
        placeholder="Type city name"
        value={formData.city}
        onChange={handleCityChange}
        autoComplete="off"
        disabled={!formData.state_id}
    />

      {showSuggestions && filteredCities.length === 0 && formData.city && (
        <div className="no-city-msg">
            Type your City it will be added automatically
        </div>
    )}

    {/* Suggestions Dropdown */}
    {showSuggestions && filteredCities.length > 0 && (
      
        <ul className="suggestions-list">
            {filteredCities.map((c) => (
                <li key={c.id} onClick={() => selectCity(c)}>
                    {c.city_name}
                </li>
            ))}
        </ul>
    )}

    <p className={`validation-msg ${errors.city_id ? "show" : ""}`}>
        {errors.city_id}
    </p>
                        </div>

                    </div>
                    {/* area */}
                    <div className={`input-wrapper ${errors.area ? "error-active" : ""}`}>
                                <input type="text"  className="step-input" name="area" placeholder="Area" value={formData.area} onChange={handleChange} />

                                <p className={`validation-msg ${errors.area ? "show" : ""}`}>
                                 {errors.area}
                                </p>
                    </div>
                    {/* location */}
                     <div className={`input-wrapper ${errors.location ? "error-active" : ""}`}>
                                <input  type="text" className="step-input" name="location" placeholder="Location" value={formData.location} onChange={handleChange}/>

                                <p className={`validation-msg ${errors.location ? "show" : ""}`}>
                                 {errors.location}
                                </p>
                    </div>
                    {/* Address_line1 */}
                    <div className={`input-wrapper ${errors.Address_line1 ? "error-active" : ""}`}>
                                <input type="text" name="Address_line1" placeholder="Address line1"
                            className="step-input" value={formData.Address_line1} onChange={handleChange} />

                                <p className={`validation-msg ${errors.Address_line1 ? "show" : ""}`}>
                                 {errors.Address_line1}
                                </p>
                    </div>
                    {/* Address_line2 */}
                    <div className={`input-wrapper ${errors.Address_line2 ? "error-active" : ""}`}>
                                <input type="text" name="Address_line2" placeholder="Address line2"
                            className="step-input" value={formData.Address_line2} onChange={handleChange} />

                                {/* <p className={`validation-msg ${errors.Address_line1 ? "show" : ""}`}>
                                 {errors.Address_line1}
                                </p> */}
                    </div>
        </div>
                    
                )}

 
 
                {/* BUTTONS */}
                <div className="btn-area">
 
                    {step > 1 && (
                        <button type="button" className="btn-prev" onClick={prevStep}>
                             Previous
                        </button>
                    )}
 
                    {step < totalSteps && (
<button
  type="button"
  className="btn-next"
  onClick={nextStep}
  disabled={!isStepValid()}
  style={{
    opacity: !isStepValid() ? 0.5 : 1,
    cursor: !isStepValid() ? "not-allowed" : "pointer"
  }}
>
  Next →
</button>


                    )}
 
                    {step === totalSteps && (
<button
  type="submit"
  className={`submit-btn ${isSubmitting || !isStepValid() ? "btn-disabled" : ""}`}
  disabled={isSubmitting || !isStepValid()}
>
  {isSubmitting ? "Registering..." : "Register"}
</button>

                    )}
 
                </div>
 
            </form>
 
            <p className="text-center mt-2" style={{marginBottom:"5px"}}>
                Already have an account? <Link to="/login" className="login-link">Login</Link>
            </p>
 
        </div>
        </div>
    </div>
</div>
 
            <Footer />
        </Fragment>
    );
};
 
export default SignupPage;

 